export const locale = {
    lang: "es",
    data: {
        CATALOGUE: {
            CAT: "Catalogo",
        },
    },
};
